import React, { FunctionComponent } from 'react';
import { IUserLogoInfo } from '../../common/models/user/IUserLogoInfo';
import Icon from '../Icon';
import Tooltip from '../Tooltip';
import styles from './styles.module.scss';

interface IUserLogoProps {
  user: IUserLogoInfo;
  border?: boolean;
  size?: string;
  fontSize?: string;
  hideTooltip?: boolean;
}

const UserLogo: FunctionComponent<IUserLogoProps> = ({
  user: {
    firstName,
    lastName,
    initials,
    isSupport
  } = {},
  fontSize,
  border,
  size,
  hideTooltip = false
}) => {
  const content = isSupport ? <Icon style={{ height: size, width: size }} icon="logo" /> : (
    <div
      style={{ height: size, width: size, fontSize }}
      className={`${styles.logo} ${border && styles.border}`}
    >
      {initials}
    </div>
  );
  return (hideTooltip || (!firstName && !lastName)) ? content : (
    <Tooltip content={`${firstName} ${lastName}`}>
      {content}
    </Tooltip>
  );
};

export default UserLogo;
